import * as d3 from "d3"
import { makeTooltip } from './modules/tooltip'

function init(results) {
	const container = d3.select("#graphicContainer")
	// console.log(results)
	var clone = JSON.parse(JSON.stringify(results));
	var data = clone.sheets.data
	var details = clone.sheets.details
	var labels = clone.sheets.labels
	var dateParse = null

	function numberFormat(num) {
        if ( num > 0 ) {
            if ( num > 1000000000 ) { return ( num / 1000000000 ) + 'bn' }
            if ( num > 1000000 ) { return ( num / 1000000 ) + 'm' }
            if ( num > 1000 ) { return ( num / 1000 ) + 'k' }
            if (num % 1 != 0) { return num.toFixed(2) }
            else { return num.toLocaleString() }
        }
        if ( num < 0 ) {
            var posNum = num * -1;
            if ( posNum > 1000000000 ) return [ "-" + String(( posNum / 1000000000 )) + 'bn'];
            if ( posNum > 1000000 ) return ["-" + String(( posNum / 1000000 )) + 'm'];
            if ( posNum > 1000 ) return ["-" + String(( posNum / 1000 )) + 'k'];
            else { return num.toLocaleString() }
        }
        return num;
    }

	var isMobile;
	var windowWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

	if (windowWidth < 1000) {
			isMobile = true;
	}	

	if (windowWidth >= 1000){
			isMobile = false;
	}

	var width = document.querySelector("#graphicContainer").getBoundingClientRect().width
	var height = 600;					
	var margin;

	if (details[0]['margin-top']) {
		margin = {top: +details[0]['margin-top'], right: +details[0]['margin-right'], bottom: +details[0]['margin-bottom'], left:+details[0]['margin-left']};
	}

	else {
		margin = {top: 220, right: 20, bottom: 20, left:40};
	}
		

	width = width - margin.left - margin.right,
    height = height - margin.top - margin.bottom;

	d3.select("#chartTitle").text(details[0].title)
    d3.select("#subTitle").html(details[0].subtitle)
    d3.select("#sourceText").html(details[0].source)
    d3.select("#footnote").html(details[0].footnote)
    d3.select("#graphicContainer svg").remove();
    var chartKey = d3.select("#chartKey");
	chartKey.html("");


	var svg = d3.select("#graphicContainer").append("svg")
				.attr("width", width + margin.left + margin.right)
				.attr("height", height + margin.top + margin.bottom)
				.attr("id", "svg")
				.attr("overflow", "hidden");



	var features = svg.append("g").attr("transform", "translate(" + margin.left + "," + margin.top + ")");

	var keys = Object.keys(data[0])

	var xVar;

	if (details[0]['xColumn']) {
		xVar = details[0]['xColumn'];
		keys.splice(keys.indexOf(xVar), 1);
	}
	
	else {
		xVar = keys[0]
		keys.splice(0, 1);
	}
	

	if (typeof details[0]['dateFormat'] != undefined) {
		dateParse = d3.timeParse(details[0]['dateFormat']);
	}

	var xAxisDateFormat = d3.timeFormat("%b %d")

	data.forEach(function(d) {
		if (typeof d[xVar] == 'string') {
			d[xVar] = dateParse(d[xVar])
		}
		keys.forEach(function(key,i) { 
			d[key] = +d[key]
		});	
	})

	labels.forEach(function (d) {
		d.x1 = dateParse(d.x1)
		
		d.x2 = dateParse(d.x2)
		d.y1 = +d.y1
		d.y2 = +d.y2
	});

    var x = d3.scaleBand().range([0, width]).paddingInner(0.08);
    var y = d3.scaleLinear().range([height, 0]);

    x.domain(data.map(function(d) { return d[xVar]; }));
	y.domain(d3.extent(data, function(d) { return d[keys[0]]; })).nice();

	var xAxis;
	var xAxis2;
	var yAxis;

	var ticks = x.domain().filter(function(d,i){ return !(i%10); } );

	if (isMobile) {
		ticks = x.domain().filter(function(d,i){ return !(i%20); } );
	}	

	if (isMobile) {
		xAxis = d3.axisBottom(x).tickValues(ticks).tickFormat(xAxisDateFormat);
		yAxis = d3.axisLeft(y).tickFormat(function (d) { return numberFormat(d)}).ticks(5);
		xAxis2 = d3.axisTop(x).tickValues(ticks).tickFormat(xAxisDateFormat).tickSize(-height - margin.top + margin.bottom)
	}

	else {
		xAxis = d3.axisBottom(x).tickValues(ticks).tickFormat(xAxisDateFormat);
		xAxis2 = d3.axisTop(x).tickValues(ticks).tickFormat(xAxisDateFormat).tickSize(-height - margin.top + margin.bottom)
		yAxis = d3.axisLeft(y).tickFormat(function (d) { return numberFormat(d)});
	}

	features.append("g")
			.attr("class","x")
			.attr("transform", "translate(0," + height + ")")
			.call(xAxis);

	features.append("g")
			.attr("class","grid")
			.attr("transform", "translate(0," + -1* (margin.top -20) + ")")
			.call(xAxis2);		

	features.append("g")
		.attr("class","y")
		.call(yAxis)

	features.selectAll(".bar")
    	.data(data)
		    .enter().append("rect")
			.attr("class", "bar")
			.attr("x", function(d) { return x(d[xVar]) })
			.style("fill", function(d) {
					return "rgb(204, 10, 17)"
			})
			.attr("y", function(d) { 
				return y(Math.max(d[keys[0]], 0))
				// return y(d[keys[0]]) 
			})
			.attr("width", x.bandwidth())
			.attr("height", function(d) { 
				return Math.abs(y(d[keys[0]]) - y(0))
			});

	makeTooltip(".bar", xAxisDateFormat);		


	function textPadding(d) {
		if (d.y2 > 0) {
			return 12
		}

		else {
			return - 2
		}
	}

	function textPaddingMobile(d) {
		if (d.y2 > 0) {
			return 4
		}

		else {
			return 4
		}
	}		

	svg.append("svg:defs").append("svg:marker")
	    .attr("id", "triangle")
	    .attr("refX", 5)
	    .attr("refY", 5)
	    .attr("markerWidth", 20)
	    .attr("markerHeight", 20)
	    .attr("orient", "auto")
	    .append("path")
	    .attr("d", "M 0 0 10 5 0 10 0 5")
	    .style("fill", "#767676");


	features.selectAll(".annotationLine")
		.data(labels)
		.enter().append("line")
		.attr("class", function(d) { return "annotationLine " + d.hide})
		.attr("x1", function(d) { return x(d.x1) + x.bandwidth()/2; })
		.attr("y1", function(d) { return y(d.y1) - d.y2})
		.attr("x2", function(d) { 

			if (x(d.x2) == undefined) {
				return x(data[data.length-1].index)
			}

			else {
				return x(d.x2) + x.bandwidth()/2;
			}
			 
		})
		.attr("y2", function(d) { 
			console.log(y(d.y1), d.y2)
			return y(d.y1) - d.y2
		})
		.style("opacity", 1)
		.attr("marker-end", "url(#triangle)")	
		.attr("stroke", "#767676");

	features.selectAll(".annotationDesktopCircles")
				.data(labels)
				.enter().append("circle")
				.attr("class", function(d) { return "annotationDesktopCircle " + d.hide})
				.attr("cy", function(d) { return y(d.y1) - d.y2 })
				.attr("cx", function(d) { return x(d.x1) + x.bandwidth()/2})
				.attr("r", 4)
				.attr("fill", "#767676");	

	var footerAnnotations = d3.select("#footerAnnotations");
	
	footerAnnotations.html("");	

	if (isMobile) {

		features.selectAll(".annotationCircles")
				.data(labels)
				.enter().append("circle")
				.attr("class", function(d) { return "annotationCircle " + d.hide})
				.attr("cy", function(d) { return y(d.y1) - d.y2 })
				.attr("cx", function(d) { return x(d.x1) + x.bandwidth()/2})
				.attr("r", 8)
				.attr("fill", "#767676");

		features.selectAll(".annotationTextMobile")
				.data(labels)
				.enter().append("text")
				.attr("class", function(d) { return "annotationTextMobile " + d.hide})
				.attr("y", function(d) { return y(d.y1) - d.y2 + textPaddingMobile(d)})
				.attr("x", function(d) { return x(d.x1) + x.bandwidth()/2})
				.style("text-anchor", "middle")
				.style("opacity", 1)
				.attr("fill", "#FFF")
				.text(function(d,i) { 
					return i + 1
				});	
		
		if (labels.length > 0) {
			footerAnnotations.append("span")
				.attr("class", "annotationFooterHeader")
				.text("Events: ");
		}

		labels.forEach(function(d,i) { 

			footerAnnotations.append("span")
				.attr("class", "annotationFooterNumber " + d.hide)
				.text(i+1 + " - ");

			if (i < labels.length -1 ) {
				footerAnnotations.append("span")
				.attr("class", "annotationFooterText " + d.hide)
				.text(d.text + ", ");
			}
			
			else {
				footerAnnotations.append("span")
					.attr("class", "annotationFooterText " + d.hide)
					.text(", " + d.text);
			}	

			

		})		

	}

	else {

		features.selectAll(".annotationText")
			.data(labels)
			.enter().append("text")
			.attr("class", function(d) { return "annotationText " + d.hide})
			.attr("y", function(d) { return y(d.y1) - d.y2  - 10 })
			.attr("x", function(d) { 

				if (x(d.x2) == undefined) {
					return x(data[data.length-1].index)
				}

				else {
					return x(d.x2) + x.bandwidth()/2;
				}
			 
			})
			.style("text-anchor", function(d) { return d.align })
			.style("opacity", 1)
			.text(function(d) {return d.text});

	}		


}	// end init

function getURLParams(paramName) {

	const params = window.location.search.substring(1).split("&")

    for (let i = 0; i < params.length; i++) {
    	let val = params[i].split("=");
	    if (val[0] == paramName) {
	        return val[1];
	    }
	}
	return null;

}

const key = getURLParams('key') //"10k7rSn5Y4x0V8RNyQ7oGDfhLvDqhUQ2frtZkDMoB1Xk"

if ( key != null ) {

	Promise.all([
		d3.json(`https://interactive.guim.co.uk/docsdata/${key}.json`)
		])
		.then((results) =>  {
			init(results[0])
			var to=null
			var lastWidth = document.querySelector("#graphicContainer").getBoundingClientRect()
			window.addEventListener('resize', function() {
				var thisWidth = document.querySelector("#graphicContainer").getBoundingClientRect()
				if (lastWidth != thisWidth) {
					window.clearTimeout(to);
					to = window.setTimeout(function() {
						    init(results[0])
						}, 100)
				}
			
			})

		});

}